module.exports = __webpack_public_path__ + "img/DFW_Bow.33603e8a.png";